import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { QUERY_KEY } from '@/utils'
import { getEnterpriseInfoDetail } from '@/services'
import { useStatusInfo } from './useStatusInfo'
import { useEnterpriseInfo } from './use-enterprise-info'

export const useCustomerInfo = () => {
  const { enterpriseInfo, isEnterpriseInfoFetched } = useEnterpriseInfo()

  const { getStatusInfo } = useStatusInfo()

  const roleValue = enterpriseInfo?.bizRole

  const {
    data: customerInfo,
    refetch: refetchCustomerInfo,
    isFetched: isCustomerInfoFetched,
  } = useQuery({
    queryKey: [QUERY_KEY.CustomerInfo],
    queryFn: getEnterpriseInfoDetail,
    staleTime: Infinity,
  })

  const statusInfo = useMemo(() => {
    if(!isCustomerInfoFetched||!isEnterpriseInfoFetched) return 
    return getStatusInfo(customerInfo?.data?.customer, roleValue)
  }, [customerInfo, roleValue])

  return {
    customerInfo: customerInfo ? customerInfo?.data?.customer : null,
    userInfoSelf: customerInfo ? customerInfo?.data?.user : null,
    getCustomerInfo: () => {
      refetchCustomerInfo()
    },
    isCustomerInfoFetched,
    statusInfo,
  }
}
